export enum OrderValueType {
  Percent = 'PERCENT',
  Amount = 'AMOUNT',
  Units = 'UNITS',
}
